<template>
    <b-row v-if="display(fieldNames.DANGEROUS_GOODS)">
        <b-col sm="6">
            <b-form-group label-cols-sm="4"
                          :label="$t('createShipment.label.Dangerous Goods')"
                          label-align-sm="left">
                <b-input-group size="sm">
                    <b-col sm="11">
                        <b-form-checkbox class="float-left"
                                         size="sm"
                                         name="dangerousGoodsCheckbox"
                                         :checked="shipment.dangerousGoods !== null"
                                         @change="handleDangerousGoods" />
                    </b-col>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="6" v-if="shipment.dangerousGoods">
            <b-form-group label-cols-sm="3"
                          :label="$t('createShipment.label.Dangerous Goods')"
                          label-align-sm="left">
                <b-input-group size="sm">
                    <b-col sm="10">
                        <vSelect :dynamicWidth="true"
                                 :options="getListOfDgTypes"
                                 :select-on-tab="true"
                                 :placeholder="$t('createShipment.placeholder.Choose DG Type')"
                                 name="dangerousGoodsList"
                                 label="dangerousGoodsTypeName"
                                 v-model="selectedDangerousGoodsType"
                                 :class="'dangerous-goods-dropdown ' +
                                    {
                                        'is-invalid':
                                            v.shipment.dangerousGoods.type.$error
                                    }"
                                 @input="handleSelectDangerousGoodsType"
                                 :clearable="false" />
                        <validationField fieldName="createShipment.label.Dangerous Goods"
                                         :validator="v.shipment.dangerousGoods.type"
                                         name="dangerousGoodsList.error"
                                         v-if="v.shipment.dangerousGoods.type.$error" />
                    </b-col>

                    <b-input-group-append>
                        <div>
                            <requiredIcon />
                        </div>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>

        <b-col sm="6"
               v-if="shipment.dangerousGoods && shipment.dangerousGoods.type != 'BATTERY'">
            <b-form-group label-cols-sm="4"
                          :label="$t('createShipment.label.PackingGroup')"
                          label-align-sm="left">
                <b-input-group size="sm">
                    <b-col sm="10">
                        <vSelect :dynamic-width="true"
                                 size="sm"
                                 name="dangerousGoodsPackingGroup"
                                 :reduce="opt => opt.value"
                                 :options="packingGroups"
                                 :select-on-tab="true"
                                 :placeholder="$t('createShipment.placeholder.Choose Packing Group')"
                                 v-model="shipment.dangerousGoods.packingGroup"
                                 :class="
                                'dangerous-goods-dropdown ' +
                                    {
                                        'is-invalid': v.shipment.dangerousGoods.packingGroup.$error
                                    }
                            "
                                 @update="v.shipment.dangerousGoods.packingGroup.$touch()"
                                 :clearable="false" />

                        <validationField fieldName="createShipment.label.PackingGroup"
                                         :validator="v.shipment.dangerousGoods.packingGroup"
                                         name="dangerousGoodsPackingGroup.error"
                                         v-if="v.shipment.dangerousGoods.packingGroup.$error" />
                    </b-col>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="6"
               v-if="shipment.dangerousGoods && shipment.dangerousGoods.type != 'BATTERY'">
            <b-form-group label-cols-sm="3"
                          :label="$t('createShipment.label.UN Number')"
                          label-align-sm="left"
                          label-for="dangerousGoodsUnNumber">
                <b-input-group size="sm">
                    <b-col sm="10">
                        <b-form-input id="dangerousGoodsUnNumber"
                                      size="sm"
                                      name="shipment.dangerousGoods.unNumber"
                                      :placeholder="$t('createShipment.placeholder.Enter UN-Number')"
                                      v-model="shipment.dangerousGoods.unNumber"
                                      :class="{
                                'is-invalid': v.shipment.dangerousGoods.unNumber.$error
                            }"
                                      @update="v.shipment.dangerousGoods.unNumber.$touch()" />
                        <validationField fieldName="createShipment.label.UN Number"
                                         :validator="v.shipment.dangerousGoods.unNumber"
                                         name="shipment.dangerousGoods.unNumber.error"
                                         v-if="v.shipment.dangerousGoods.unNumber.$error" />
                    </b-col>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="6" v-if="shipment.dangerousGoods && shipment.dangerousGoods.type === 'BATTERY'"></b-col>
      <b-col sm="6" v-if="shipment.dangerousGoods && shipment.dangerousGoods.type === 'BATTERY'">
        <b-form-group label-cols-sm="3"
                      :label="$t('createShipment.label.Battery Type')"
                      label-align-sm="left">
          <b-input-group size="sm">
            <b-col sm="10">
              <vSelect :dynamicWidth="true"
                       size="sm"
                       name="dangerousGoodsLithiumBatteriesList"
                       :options="getDangerousGoodsDescriptions"
                       :select-on-tab="true"
                       :placeholder="$t('createShipment.placeholder.Choose Battery Type')"
                       label="description"
                       v-model="shipment.dangerousGoods.lithiumBatteryType"
                       :class="{
                            'dangerous-goods-dropdown': true,
                            'is-invalid': !shipment.dangerousGoods.lithiumBatteryType
                        }"
                       @input="handleSelectLithiumBatteryType"
                       :clearable="false" />

              <b-form-invalid-feedback
                  v-if="!shipment.dangerousGoods.lithiumBatteryType"
                  :name="'dangerousGoodsLithiumBatteriesList.error'">
                {{ $t('Battery Type cant be empty') }}
              </b-form-invalid-feedback>
            </b-col>
            <div>
              <requiredIcon />
            </div>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
</template>

<script>
    import vSelect from './vSelect';
    import 'vue-select/dist/vue-select.css';
    import viewOptions from '../mixins/viewOptionsMixin';
    import resetMixin from '../mixins/resetMixin';
    import { FIELD_NAMES } from '../store/nameConstants';
    import { ACTIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
    import { mapGetters } from 'vuex';
    import helpers from '../helper';
    import validationField from './Validation/ValidationField';
    import requiredIcon from './requiredIcon';
    import PackingGroup from "@/components/CreateShipment/DangerousGoods/packingGroup";

    export default {
        components: {
            PackingGroup,
            vSelect,
            validationField,
            requiredIcon,
        },

        props: {
            shipment: { required: true },
            v: { required: true },
        },

        mixins: [viewOptions, resetMixin],

        data() {
            return {
                isDangerousGoods: false,
                fieldNames: FIELD_NAMES,
                packingGroups: [{ label: 'Not applicable', value: 'NotApplicable' }, { label: "I", value: 'I' }, { label: "II", value: 'II' }, { label: "III", value: 'III' }],
                selectedDangerousGoodsType: null,
                selectedLithiumBatteryType: null,
            };
        },

        watch: {
            isDangerousGoods: function (val) {
                this.$store.dispatch(
                    CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                );
            },
            reset() {
                this.isDangerousGoods = false;
                this.v.$reset();
            },
            'shipment.dangerousGoods.description': {
                deep: true,
                handler() {
                    this.$store.dispatch(
                        CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                    );
                },
            },
            'shipment.dangerousGoods': {
                deep: true,
                handler(newVal) {
                    if (newVal && newVal.lithiumBatteryType) {
                        const selectedOption = this.getDangerousGoodsDescriptions.find(
                            option => option.lithiumBatteryType === newVal.lithiumBatteryType
                        );
                        this.selectedLithiumBatteryType = selectedOption;
                    }
                    if (newVal && newVal.type) {
                        const selectedOption = this.getListOfDgTypes.find(
                            option => option.type === newVal.type
                        );
                        this.selectedDangerousGoodsType = selectedOption;
                    }
                },
            },
        },

        methods: {
            handleDangerousGoods(enableDangerousGoods) {
                if (enableDangerousGoods) {
                    this.shipment.dangerousGoods = {
                        type: null,
                        unNumber: null,
                        packingGroup: null,
                        lithiumBatteryType: null
                    };
                } else {
                    this.shipment.dangerousGoods = null;
                }
            },

            handleSelectDangerousGoodsType(selectedOption) {
                this.shipment.dangerousGoods.type = selectedOption.type;
                if (selectedOption.type !== 'BATTERY') {
                    this.shipment.dangerousGoods.lithiumBatteryType = null;
                } else {
                    this.shipment.dangerousGoods.unNumber = null;
                }
            },

            handleSelectLithiumBatteryType(selectedOption) {
                this.shipment.dangerousGoods.lithiumBatteryType = selectedOption.lithiumBatteryType;
            },
        },

        computed: {
            ...mapGetters('createShipment', [
                'getDangerousGoodsDescriptions',
                'getListOfDgTypes',
                'getIsDangerousGoods',
            ]),
        },
    };
</script>

<style>
    .dangerous-goods-dropdown div div span {
        width: 170px !important;
    }
</style>
